export const userDetails = () => {
    let user = localStorage.getItem("user")
    if (user) {
        let value = JSON.parse(user);
        return value
    }
}